import { render } from "./tplCommittees.vue?vue&type=template&id=8d4fdc22&scoped=true"
import script from "./tplCommittees.vue?vue&type=script&lang=js"
export * from "./tplCommittees.vue?vue&type=script&lang=js"

import "./tplCommittees.vue?vue&type=style&index=0&id=8d4fdc22&scoped=true&lang=css"
import "./tplCommittees.vue?vue&type=style&index=1&id=8d4fdc22&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4fdc22"]])

export default __exports__